module.exports = __webpack_public_path__ + "static/snowboarding-3-d4ad412b57c74ff8d59d1c8c1f18531e.jpg";